import { render, staticRenderFns } from "./textareatemplate.vue?vue&type=template&id=56ac5693&scoped=true&"
import script from "./textareatemplate.vue?vue&type=script&lang=js&"
export * from "./textareatemplate.vue?vue&type=script&lang=js&"
import style0 from "./textareatemplate.vue?vue&type=style&index=0&id=56ac5693&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ac5693",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCardText,VForm,VTab,VTabItem,VTabs,VTabsItems})
